import { render, staticRenderFns } from "./PartSoldList.vue?vue&type=template&id=77b7b20c"
import script from "./PartSoldList.vue?vue&type=script&lang=ts"
export * from "./PartSoldList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports